import React from 'react'
import PropTypes from 'prop-types'

import {
  getNewsletterPosts,
  getNewsletterByMonth,
  getNewsletterBySlugWithSEO,
} from '@/lib/blog/newsletter'
import { Layout, Section } from '@/components/layout'
import { SeoBlog } from '@/components/layout/Seo'
import { mapPostSeo } from '@/utils/seo'
import NewsletterHeader from '@/components/blocks/NewsletterHeader'

import styles from './newsletter-archive.module.scss'

export default function NewsletterIssue({ post, seo }) {
  return (
    <>
      <SeoBlog seoDetails={seo} />
      <Layout.Content>
        <Section>
          <NewsletterHeader title={post.title} />
          {post.featuredImage?.node?.sourceUrl && (
            <img
              alt={post.featuredImage.node.altText}
              className={styles.postImage}
              height={post.featuredImage.node.mediaDetails?.height}
              src={post.featuredImage.node.sourceUrl}
            />
          )}
          <div
            className={styles.postContent}
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
        </Section>
      </Layout.Content>
    </>
  )
}

NewsletterIssue.propTypes = {
  post: PropTypes.shape({
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    content: PropTypes.string,
    featuredImage: PropTypes.shape({
      node: PropTypes.shape({
        sourceUrl: PropTypes.string,
        altText: PropTypes.string,
        mediaDetails: PropTypes.shape({
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      }),
    }),
  }).isRequired,
  seo: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    canonical: PropTypes.string,
    openGraph: PropTypes.shape({
      url: PropTypes.string,
      type: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    jsonLD: PropTypes.shape({
      webPage: PropTypes.shape({}),
      article: PropTypes.shape({}),
      person: PropTypes.shape({}),
    }),
    additionalMetaTags: PropTypes.arrayOf(
      PropTypes.shape({
        rel: PropTypes.string,
        href: PropTypes.string,
      }),
    ),
  }),
}

NewsletterIssue.layoutProps = { pageId: 'newsletterIssue' }

export async function getStaticProps({ params }) {
  const match = await getNewsletterByMonth(params.issue)

  if (!match) {
    return { notFound: true }
  }

  const { post } = await getNewsletterBySlugWithSEO(match.slug)

  if (!post) {
    return { notFound: true }
  }

  const seo = mapPostSeo(post)

  return {
    props: { post, seo },
    revalidate: 60,
  }
}

export async function getStaticPaths() {
  const posts = await getNewsletterPosts()
  const paths = posts.map((post) => ({
    params: { issue: new Date(post.date).toISOString().slice(0, 7) },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}
